<template>
    <div class="container">
        <h1 class="title">¿Cómo funciona?</h1>
        <div class="cards">
            <div>
        <div class="tarject">
            <v-icon name="ri-money-euro-circle-fill" style="scale: 5.00; color: #d9d9d9; margin-left: 89%;"></v-icon>
            <h3 class="text-title">Regístrate Gratis</h3>
            <p class="text-tarject">
                Regístrate ahora de forma gratuita y sencilla y podrás empezar a publicar tus ofertas de manera inmediata.
            </p>
        </div> 
        <div class="circle-green"></div>
    </div>     
        <div class="tarject" style="margin-top: 120px;">
            <v-icon name="ri-steam-fill" style="scale: 5.00; color: #d9d9d9; margin-left: 89%;"></v-icon>
            <h3 class="text-title">Publica Tu Oferta</h3>
            <p class="text-tarject">
                Publica tu oferta en nuestra plataforma para que nuestros más de 65.000 desarrolladores puedan visualizarla y aplicar a ella.
            </p>
        </div>
    <div class="circle"></div>
        <div class="tarject" style="margin-top: 120px;">
            <v-icon name="hi-solid-user-circle" style="scale: 5.00; color: #d9d9d9; margin-left: 89%;"></v-icon>
            <h3 class="text-title">Selecciona Candidatos</h3>
            <p class="text-tarject">
                Accede a tu área de empresa y selecciona los candidatos que mejor se ajustan a tu perfil para cubrir tus necesidades.</p>
        </div>
        <div class="circles">
        <div class="tarject">
            <v-icon name="fa-check-circle" style="scale: 5.00; color: #d9d9d9; margin-left: 89%;"></v-icon>
            <h3 class="text-title">Totalmente Gratuito</h3>
            <p class="text-tarject">
               Nuestro modelo ProDev de formación avanzada por suscripción nos permite no cobrar nada a las empresas y facilitar la inserción al mercado laboral de nuestros alumnos.</p>
        </div>
        <div class="circle-green-2" ></div>
    </div>
</div>
    </div>
</template>

<script setup>
</script>

<style scoped>
@media screen and (max-width: 600px){
    .container{
        margin-top: 0;
     width: 100%;
    }
    .title{
        margin-top: 0;
        margin-right: 4%;
        width: 90%;
    }
}
.container {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.cards{
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    width: 100%;
   
}

.title {
    color: rgba(196, 207, 44, 1);
    height: auto;
    font-size: 60px;
    font-style: Black;
    text-align: center;
    font-family: Darker Grotesque;
    font-weight: 900;
    line-height: 94.9999988079071%;

}

.tarject {
    background-color: #ffffff;
    box-shadow: 2px 2px 2px #d9d9d9;
    border: none;
    width: 250px;
    padding: 10px;
    height: 277px;
    margin: 20px;
}

.text-title {
    color: rgba(39, 52, 68, 1);
    font-size: 28px;
    font-style: Bold;
    font-family: Darker Grotesque;
    font-weight: 700;

}

.text-tarject {
    color: rgba(39, 52, 68, 1);
    width: 199px;
    height: auto;
    font-size: 20px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}
.circle {
  width: 60px;
  height: 60px;
  background-color: #2ea3f2;
  border-radius: 50%; /* Esto hace que el div sea un círculo */
}
.circle-green {
  width: 40px;
  height: 40px;
  background-color: #c4cf2c;
  border-radius: 50%;
  margin-left: 60%; /* Esto hace que el div sea un círculo */
}
.circle-green-2 {
  width: 50px;
  height: 50px;
  background-color: #c4cf2c;
  border-radius: 50%;
}
.circles{
    display: flex;
    flex-direction: column;
}
</style>